import React from "react";
import { Typography } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { BootstrapInput } from "./bootstrapInput";

class AvailableCustomWithURL extends React.Component {
  render() {
    console.log(this.props.connection.connectorName);
    return (
      <React.Fragment>
        <Typography component="h5" variant="h6" className={this.props.classes.urlDescription}>
          The subdomain name for your {this.props.connection.connectorName} account.
        </Typography>
        <div className={this.props.classes.dataContainerUrl}>
          <InputLabel htmlFor="bootstrap-input" className={this.props.classes.urlLinkDesc}>
            https://
          </InputLabel>
          <FormControl className={this.props.classes.margin}>
            <BootstrapInput
              id="connectorUrl"
              autoFocus
              value={this.props.state[this.props.connection.connectionName]["values"].url}
              onChange={event => this.props.handleFieldChange("url", event.target.value)}
            />
          </FormControl>
          <InputLabel htmlFor="bootstrap-input" className={this.props.classes.urlLinkDesc}>
            {this.props.state[this.props.connection.connectionName].label}
          </InputLabel>
        </div>
        {this.props.state[this.props.connection.connectionName]["errors"].url && (
          <Typography className={this.props.classes.fieldError} variant="body2">
            {this.props.state[this.props.connection.connectionName]["errors"].url}
          </Typography>
        )}
      </React.Fragment>
    );
  }
}

export default AvailableCustomWithURL;
